/*@ngInject*/
const HeaderController = function () {

};

angular.module('gw-um-header')
    .controller('headerController', HeaderController);
